module.exports = __webpack_public_path__ + "static/media/vivo.0811d140.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/vivo.png
// module id = 2411
// module chunks = 7